import React from "react";
import Modal from 'apollo-react/components/Modal';
import Typography from 'apollo-react/components/Typography';
import FileInput from 'apollo-react/components/FileInput';
import { STATUSES } from "../../../../constants/statuses";
import './styles.css';

// Add Comment Modal
export const AddCommentModal = ({
  isOpen,
  commentText,
  onCommentChange,
  selectedFile,
  onFileChange,
  onSubmit,
  onClose,
}) => {
  const buttonProps = [
    { label: "Cancel", onClick: onClose, variant: 'secondary' },
    { label: "Submit", onClick: onSubmit },
  ]

  const handleFileInputChange = (file) => {
    if (file) {
      console.log("File selected:", file.name)
      onFileChange(file)
    }
  }

  return (
    <Modal open={isOpen} onClose={onClose} title="Add Comment" buttonProps={buttonProps} id="add-comment-modal">
      <div className="form-group">
        <textarea
          id="comment"
          placeholder="Comment"
          value={commentText}
          onChange={(e) => onCommentChange(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          rows={4}
        />
      </div>
      <div style={{ marginBottom: '16px' }}>
        <FileInput
          onChange={handleFileInputChange}
          buttonText="Browse"
          helperText="Upload a file (Optional)"
          placeholder={selectedFile ? selectedFile.name : "No file selected"}
          label="Attach File"
          fullWidth
          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
        />
      </div>
    </Modal>
  )
}


// View Comments Modal
export const ViewCommentsModal = ({ 
  isOpen, 
  selectedRow,
  onClose 
}) => {
  if (!selectedRow) return null;

  const comments = selectedRow.comments || [];

  const buttonProps = [
    { label: 'Close', onClick: onClose, variant: 'secondary' }
  ];

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="View Comments"
      buttonProps={buttonProps}
      id="view-comments-modal"
    >
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {comments.length > 0 ? (
          comments.map((comment) => (
            <div key={comment.id} style={{ marginBottom: 16, padding: 12, border: '1px solid #eee', borderRadius: 4 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                  {comment.author}
                </Typography>
                <Typography variant="caption" style={{ color: '#666' }}>
                  {comment.date}
                </Typography>
              </div>
              <Typography variant="body2" style={{ marginBottom: 8 }}>
                {comment.text}
              </Typography>
              {comment.attachment && (
                <div style={{ padding: 8, backgroundColor: '#f9f9f9', borderRadius: 4 }}>
                  <a 
                    href={comment.attachment.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: '#0066cc' }}
                  >
                    📎 {comment.attachment.name}
                  </a>
                </div>
              )}
            </div>
          ))
        ) : (
          <Typography variant="body2" style={{ textAlign: 'center', color: '#666', padding: 20 }}>
            No comments available
          </Typography>
        )}
      </div>
    </Modal>
  );
};

// Popup Menu Component
export const CommentPopupMenu = ({ 
  isOpen, 
  position, 
  onViewComments, 
  onAddComment, 
  onClose,
  requestProgress
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="popup-overlay" onClick={onClose}></div>
      <div 
        className="popup-menu popup-menu-positioned"
        style={{
          left: position.x,
          top: position.y
        }}
      >
        <button className="popup-menu-item" onClick={onViewComments}>
          View Comments
        </button>
        {requestProgress?.status === STATUSES.COMMITTEE_REVIEW && <button className="popup-menu-item" onClick={onAddComment} >
          {/* disabled={requestProgress?.status !== "core-active"} */}
          Add Comment
        </button>}
      </div>
    </>
  );
};
